module.exports = __webpack_public_path__ + "img/steam.17470574.svg";